import React, { type FC } from 'react';
import classes from '../styles/index.module.css';
import { TooltipBtn } from '../../../../../ReactSharedScripts/components/TooltipBtn';
import { useStyleContextState } from '../../../../../ReactSharedScripts/modules/styleContext';
import {
	useToolNavigationRoleSwitcherProvider,
} from '../../../../../ReactSharedScripts/modules/toolNavigation/components/ToolNavigationRoleSwitcherProvider';
import { Gear } from '../../../../../ReactSharedScripts/components/Icons/Gear';
import { User } from '../../../../../ReactSharedScripts/components/Icons/User';
import { ToolNavigationCollapsedRoleSwitcherTooltip } from './ToolNavigationCollapsedRoleSwitcherTooltip';

export const ToolNavigationCollapsedRoleSwitcher: FC = () => {
	const { theme } = useStyleContextState();
	const { isAdmin } = useToolNavigationRoleSwitcherProvider();

	return (
		<div className={classes.toolNavigation__collapsedRoleSwitcher}>
			<TooltipBtn
				className={classes.toolNavigation__collapsedRoleSwitcherButton}
				tooltip={<ToolNavigationCollapsedRoleSwitcherTooltip />}
				tooltipTheme={theme}
				tooltipPosition='right'
				tooltipAlign='start'
			>
				{isAdmin ? <Gear /> : <User />}
			</TooltipBtn>
		</div>
	);
};
